import { DefaultOptions, QueryClient, MutationCache, Query } from '@tanstack/react-query'
import { codeAppApiTypes } from '@/types'

export type StudioProject = codeAppApiTypes.components['schemas']['StudioProject']
export type StudioRoute = codeAppApiTypes.components['schemas']['StudioRoute']
export type CodeAppConfig = codeAppApiTypes.components['schemas']['CodeAppConfig']
export type StudioSecret = codeAppApiTypes.components['schemas']['StudioSecret']

const queryConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 2 * 60 * 1000, // 2 min
  },
}

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      const nonStaticQueries = (query: Query) => {
        const defaultStaleTime = queryClient.getQueryDefaults(query.queryKey).staleTime ?? 0
        const staleTimes = query.observers
          .map((observer) => observer.options.staleTime)
          .filter((staleTime) => staleTime !== undefined)

        const staleTime = query.getObserversCount() > 0 ? Math.min(...(staleTimes as number[])) : defaultStaleTime

        return staleTime !== Number.POSITIVE_INFINITY
      }

      queryClient.invalidateQueries({
        queryKey: mutation.options.mutationKey,
        predicate: nonStaticQueries,
      })
    },
  }),
})
